


































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { format, parseISO } from 'date-fns';
import { BDropdown, BDropdownItem, BTable } from 'bootstrap-vue';
import IconBox from '../../box/IconBox.vue';
import { ticketingDisconnect, ticketingCheckConnection } from '@/utils/crudActions';
import { TicketingConnectionCheck } from '@/pages/settings/servicenow/types';

export default Vue.extend({
  name: 'ListConnections',
  components: {
    BDropdown,
    BDropdownItem,
    BTable,
    IconBox,
  },
  props: {
    connectionItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      test: null,
      fields: [
        { label: 'ServiceNow instance URL', key: 'servicenowInstanceUrl' },
        { label: 'ServiceNow username', key: 'servicenowUsername' },
        { label: 'Authentication type', key: 'authenticationType' },
        {
          label: 'Date added',
          key: 'dateAdded',
          formatter: (date: String) => {
            if (!date) {
              return '';
            }

            return format(parseISO(date), 'MM/d/yyyy');
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['csrfToken', 'routes']),
  },
  async created() {},
  methods: {
    ...mapActions({
      showAlert: 'alerts/show',
      showModal: 'modals/show',
    }),
    async confirmDeletion() {
      try {
        await this.showModal({
          type: 'ConnectionDeleteCard',
          data: {
            connectionName: 'ServiceNow',
          },
        });
        this.disconnect();
      } catch {
        // User closed modal
      }
    },
    ticketingDisconnect,
    ticketingCheckConnection,
    testConection() {
      this.ticketingCheckConnection()
        .then(() => {
          this.showAlert({ type: 'success', message: 'ServiceNow connection successful!' });
        })
        .catch((resp: TicketingConnectionCheck) => {
          this.showAlert({ type: 'error', message: resp.message });
        });
    },
    disconnect() {
      this.ticketingDisconnect().then(() => {
        this.showAlert({ type: 'error', message: 'ServiceNow is now disconnected' });
        this.$router.go();
      });
    },
  },
});
